import * as env from 'lib/env'

/**
 * Utility module to generate path for static assets: fonts, icon, images based on basePath set in next.config.js
 * This to avoid hard-coding basePath in various locations
 */

/**
 * default to empty if NEXT_PUBLIC_BASE_PATH not set in .env, otherwise basePath will have undefined value
 */
const basePath = env.BASE_PATH || ''
const appendBuildId = env.BUILD_ID ? `-${env.BUILD_ID}` : ''

export const iconsPath = `${basePath}/icons/icons${appendBuildId}.svg`
export const imagesPath = `${basePath}/images`
export const fontsPath = `${basePath}/fonts`

